import { transparentize } from 'polished'
import styled from 'styled-components'
import { BLUE_LIGHTER, WHITE } from '../../utils/colors'

export const Container = styled.a`
  cursor: pointer;

  img {
    width: auto;
  }

  &:hover {
    background-color: ${transparentize(0.5, BLUE_LIGHTER)};
  }
  display: flex;
  transition: ease-in-out all 0.3s;
  background-color: ${transparentize(0.77, BLUE_LIGHTER)};
  border-radius: 6px;
  padding: 17px;
  align-items: center;
  text-decoration: none;
  line-height: 21px;
  margin-bottom: 24px;
  position: relative;

  .zendesk {
    position: absolute;
    top: 9px;
    right: 0px;
  }

  color: ${WHITE};

  b {
    font-weight: 700;
  }
  img {
    margin: 8px 24px 8px 8px;
  }

  b {
    display: block;
  }
`
